import type { FC } from "react";
import { Col, Row } from "react-bootstrap";
import {
	useGoogleMyBusinessActions,
	useGoogleMyBusinessLocationsMedia,
} from "../settings/useIntegrations";
import "./FormBusinessMedia.css";
import { useEventCallback } from "usehooks-ts";
import { useModal } from "../common/modal/Modal";
import { Button } from "../components/Button";
import { ModalSelectMedia } from "../post/ModalSelectMedia";
import { BusinessMedia } from "./BusinessMedia";

type Props = {
	locationID: string;
};

export const FormBusinessMedia: FC<Readonly<Props>> = ({ locationID }) => {
	const media = useGoogleMyBusinessLocationsMedia(locationID);
	const { uploadBusinessMedia } = useGoogleMyBusinessActions();
	const { mutateAsync: uploadMutateAsync, isPending } = uploadBusinessMedia;
	const { open } = useModal();

	const handleUploadMedia = useEventCallback((ids: Array<number>) => {
		uploadMutateAsync({
			locationID,
			ids,
		});
	});

	const handleOpenMedia = useEventCallback(() => {
		open(ModalSelectMedia, {
			values: [] as number[],
			onChange: handleUploadMedia,
		});
	});

	return (
		<>
			<Button
				icon="add_circle"
				iconSize={24}
				aria-label="add file"
				className="trigger"
				loading={isPending}
				onClick={handleOpenMedia}
				full
			>
				Add Media
			</Button>
			<Row className="business-media">
				{media.media.map((mediaItem) => (
					<Col
						className="business-media-col"
						md={6}
						key={mediaItem.url ?? mediaItem.thumbnailUrl}
					>
						<BusinessMedia locationID={locationID} mediaItem={mediaItem} />
					</Col>
				))}
			</Row>
			{media.customersMedia.length > 0 && (
				<>
					<h3>Customer Media</h3>
					<Row className="business-media">
						{media.customersMedia.map((mediaItem) => (
							<Col
								className="business-media-col"
								md={6}
								key={mediaItem.url ?? mediaItem.thumbnailUrl}
							>
								<BusinessMedia locationID={locationID} mediaItem={mediaItem} />
							</Col>
						))}
					</Row>
				</>
			)}
		</>
	);
};
